import { css } from '@emotion/react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { Authn } from '@frontend/auth';
import { ShellTitleBar } from '@frontend/shell-theme';
import { TracerModal } from '@frontend/tracer-modal';
import { theme } from '@frontend/theme';

const hasShellThemeEnabled =
  window.shell && window.shell?.isShell && window.shell?.featureAvailability?.has('shell-theme');

const Root = () => {
  return (
    <>
      <>
        {hasShellThemeEnabled && <ShellTitleBar />}
        <div
          css={css`
            display: flex;
            flex: 1;
            justify-content: center;
          `}
        >
          <main
            css={css`
              display: flex;
              flex: 1;
              flex-direction: column;
              justify-content: center;
              background-color: ${theme.colors.white};
            `}
          >
            <div
              css={css`
                display: flex;
                flex-direction: column;
                height: 100%;
              `}
            >
              <Outlet />
            </div>
          </main>
        </div>
      </>
      <TracerModal />
    </>
  );
};

export const Route = createRootRouteWithContext<{ auth: Authn }>()({
  component: Root,
  notFoundComponent: () => <div>Not Found</div>,
});
